import * as React from 'react';
import { classes, style } from 'typestyle';
import { GrayLight, White } from '../../../styles/colors';
const List = (props) => {
    const { children, bordered, noLastItemBorder, className = '' } = props;
    const borderClassNames = [bordered ? separatedStyle : ''];
    return (React.createElement("div", { className: classes(`ta-list`, listStyle, className, ...borderClassNames, noLastItemBorder && noLastItemBorderStyle) }, children));
};
export default List;
// CSS patterns
const listStyle = style({
    display: 'flex',
    flexDirection: 'column',
    background: White,
});
const bottomInsetBorderCss = {
    boxShadow: `0 -1px ${GrayLight} inset`,
};
const separatedStyle = style({
    $nest: {
        '& .ta-list-item .ta-center-cell': Object.assign({}, bottomInsetBorderCss),
        '& .ta-list-item .ta-right-cell': Object.assign({}, bottomInsetBorderCss),
        '& .ta-list-item:last-of-type .ta-left-cell': Object.assign({}, bottomInsetBorderCss),
    },
});
const noBottomInsetBorderCss = {
    boxShadow: `none`,
};
const noLastItemBorderStyle = style({
    $nest: {
        '& .ta-list-item:last-of-type .ta-center-cell': Object.assign({}, noBottomInsetBorderCss),
        '& .ta-list-item:last-of-type .ta-right-cell': Object.assign({}, noBottomInsetBorderCss),
        '& .ta-list-item:last-of-type .ta-left-cell': Object.assign({}, noBottomInsetBorderCss),
    },
});
//# sourceMappingURL=List.js.map